module.exports = __webpack_public_path__ + "4806f8298485057c8fc83dd290b19df1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/foerdermitglied.jpg
// module id = 768
// module chunks = 0